import React, {useEffect, useMemo, useState} from "react";
import {buildStyles} from "connectui/component/buildStyles";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import MessageNotification from "./content/MessageNotification";
import ButtonText from "connectui/component/input/button/ButtonText";
import Text from "connectui/component/display/Text";

const useStyles = (theme) =>
  buildStyles({
    detailsButton: {
      border: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
      padding: theme.spacing(0, 1),
    },
  });

const GroupedNotifications = ({msg}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const [expanded, setExpanded] = useState(false);
  const totalErrors = useMemo(
    () =>
      msg.messages
        .slice(1)
        .reduce((acc, curr) => (!!curr.errors?.length ? acc + 1 : acc), 0),
    [msg],
  );

  return (
    <FlexContainer
      flexDirection="column"
      justifyContent="center"
      gap={theme.spacing(1)}
      sx={{width: "100%"}}
    >
      <MessageNotification
        message={msg.messages[0]}
        actions={
          <FlexContainer>
            {!!totalErrors && (
              <Text
                variant="textXS"
                color="error600"
              >{`${totalErrors} failed`}</Text>
            )}
            <ButtonText
              typographyVariant="textXS"
              weight="semibold"
              color="primary"
              className={classes.detailsButton}
              label={expanded ? "Hide Details" : "View Details"}
              onClick={() => setExpanded((prev) => !prev)}
            />
          </FlexContainer>
        }
      />
      {!!expanded &&
        msg.messages.map((notif, i) => {
          if (i === 0) {
            return null;
          }

          return (
            <MessageNotification
              key={notif.id ?? notif.sent}
              notificationOnly
              message={notif}
              textColor="textTertiary"
            />
          );
        })}
    </FlexContainer>
  );
};

export default GroupedNotifications;
